import { combineReducers } from 'redux';

import tenantReducer from './tenant';

const reducer = combineReducers({
    tenant: tenantReducer
});

export default reducer;
